/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_UpInputs */

const en_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up`)
};

const de_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrieren`)
};

const fr_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'inscrire`)
};

const es_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrarse`)
};

const it_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrati`)
};

const nl_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registreren`)
};

const pl_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarejestruj się`)
};

const fi_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekisteröidy`)
};

const da_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret konto`)
};

const sv_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa konto`)
};

/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Auth_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_sign_up = /** @type {((inputs?: Auth_Sign_UpInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_UpInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_sign_up(inputs)
	if (locale === "fr") return fr_auth_sign_up(inputs)
	if (locale === "es") return es_auth_sign_up(inputs)
	if (locale === "it") return it_auth_sign_up(inputs)
	if (locale === "nl") return nl_auth_sign_up(inputs)
	if (locale === "pl") return pl_auth_sign_up(inputs)
	if (locale === "fi") return fi_auth_sign_up(inputs)
	if (locale === "da") return da_auth_sign_up(inputs)
	if (locale === "sv") return sv_auth_sign_up(inputs)
	return en_auth_sign_up(inputs)
});